module.exports = require('./helpers/bundle-url').getBundleURL('46bxV') + require('./helpers/bundle-manifest').resolve("a8VeM");